import { NetworkStatus, QueryResult } from '@apollo/client'
import { Snack, Spinner } from '@nike/eds'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorSnack } from './components/errorsnack/ErrorSnack'
import { GraphQLError } from 'graphql/error/GraphQLError'

export type ApolloResultProps = React.PropsWithChildren<
  Pick<QueryResult, 'networkStatus' | 'error'>
>

export interface AppSyncGraphQLError extends GraphQLError {
  errorType: string
}

export function ApolloResult({
  networkStatus,
  error,
  children,
}: ApolloResultProps): React.ReactElement {
  if (networkStatus === NetworkStatus.loading || networkStatus === NetworkStatus.setVariables) {
    return <Spinner size="large" />
  }
  if (networkStatus === NetworkStatus.error) {
    if (
      error.graphQLErrors?.every(
        (ge) => (ge as AppSyncGraphQLError).errorType === 'OpenSearch:UserIllegalArgumentException'
      )
    ) {
      return (
        <Snack id="warning-snack" hideDismiss={true} status="info">
          Not found
        </Snack>
      )
    } else {
      return <ErrorSnack error={error} />
    }
  }
  return (
    <ErrorBoundary resetKeys={[networkStatus]} FallbackComponent={ErrorSnack}>
      {children}
    </ErrorBoundary>
  )
}
